"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagPickerOptionClassNames: function() {
        return tagPickerOptionClassNames;
    },
    useTagPickerOptionStyles_unstable: function() {
        return useTagPickerOptionStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactcombobox = require("@fluentui/react-combobox");
const tagPickerOptionClassNames = {
    root: 'fui-TagPickerOption',
    media: 'fui-TagPickerOption__media',
    secondaryContent: 'fui-TagPickerOption__secondaryContent'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f13qh94s",
        Budl1dq: "fjxzuw",
        Bt984gj: "f122n59"
    },
    secondaryContent: {
        Br312pm: "fd46tj4",
        Ijaq50: "faunodf"
    },
    media: {
        Ijaq50: "fldnz9j"
    }
}, {
    d: [
        ".f13qh94s{display:grid;}",
        ".fjxzuw{grid-template-columns:auto 1fr;}",
        ".f122n59{align-items:center;}",
        ".fd46tj4{grid-column-start:2;}",
        ".faunodf{grid-row-start:2;}",
        ".fldnz9j{grid-row-start:span 2;}"
    ]
});
const useTagPickerOptionStyles_unstable = (state)=>{
    'use no memo';
    (0, _reactcombobox.useOptionStyles_unstable)({
        ...state,
        active: false,
        disabled: false,
        focusVisible: false,
        checkIcon: undefined,
        selected: false
    });
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(tagPickerOptionClassNames.root, styles.root, state.root.className);
    if (state.media) {
        state.media.className = (0, _react.mergeClasses)(tagPickerOptionClassNames.media, styles.media, state.media.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(tagPickerOptionClassNames.secondaryContent, styles.secondaryContent, state.secondaryContent.className);
    }
    return state;
};
